<template>
  <v-toolbar
    app
    fixed
    clipped-right
    clipped-left
    flat
    height="80px"
    color="white"
    class="toolbar"
  >
    <div
      class="sidebar-toggle hidden-lg-and-up"
    >
      <v-btn
        icon
        @click="toggleMenu"
      >
        <v-icon>
          menu
        </v-icon>
      </v-btn>
    </div>
    <router-link to="/home">
      <v-toolbar-title>
        <img
          src="@/assets/images/carela-logo.png"
          alt="Carela"
          class='logo'
        >
      </v-toolbar-title>
    </router-link>

    <v-spacer />

    <slot name="navigation" />

    <v-flex
      v-if="$route.meta.auth"
      shrink
      px-3
      class="user-info"
    >
      <span
        v-if="user.group && !user.admin"
        class="highlight"
      >
        {{ user.group.name }}
      </span>
      <span
        class="highlight"
      >
        {{ user.firstname }} {{ user.lastname }}
      </span>
      <br>
      <span v-if="user.admin">Administrator</span>
    </v-flex>

    <v-menu min-width="320">
      <template
        v-slot:activator="{on}"
      >
        <v-btn
          flat
          icon
          v-on="on"
        >
          <v-icon>
            expand_more
          </v-icon>
        </v-btn>
      </template>
      <v-list
        class="drawer-list"
      >
        <v-list-tile
          v-if="!$route.meta.auth"
          :to="{ name: 'login.index' }"
        >
          {{ $t("general.navigationDrawer.links.login") }}
        </v-list-tile>

        <v-list-tile
          v-if="$route.meta.auth"
          :to="{ name: 'home.index' }"
        >
          {{ $t("general.navigationDrawer.links.home") }}
        </v-list-tile>

        <v-list-tile
          v-if="$route.meta.auth && (this.$store.state.auth.user.admin || this.$store.state.auth.user.isCompanyOwner)"
          :to="{ name: 'admin.index' }"
        >
          {{ $t("general.navigationDrawer.links.admin") }}
        </v-list-tile>

        <v-list-tile
          :href="resetPasswordLink"
        >
          {{ $t("general.navigationDrawer.links.resetPassword") }}
        </v-list-tile>

        <v-list-tile
          v-if="$route.meta.auth"
          content-class="v-list__tile--link"
          @click.stop="dialogVisible = true"
        >
          {{ $t("general.navigationDrawer.links.logout") }}
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-dialog
      v-model="dialogVisible"
      full-width
      content-class="custom-logout-dialog"
    >
      <div
        class="back-button"
        @click="toggleLogoutDialog"
      >
        <a href="#">
          <span />
          <span />
        </a>
      </div>
      <div class="custom-dialog__card">
        <v-card class="">
          <v-card-text>
            {{ $t("general.navigationDrawer.logoutDialog.text") }}
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="secondary"
              flat="flat"
              class="cancel"
              @click="toggleLogoutDialog"
            >
              {{ $t("general.navigationDrawer.logoutDialog.cancel") }}
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              class="confirm"
              min-height="65px"
              rounded
              @click="logout"
            >
              {{ $t("general.navigationDrawer.logoutDialog.logout") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import SlotMixin from '@/mixins/slot';
import { mapState } from 'vuex';

export default {
  name: 'Navigation',

  mixins: [
    SlotMixin,
  ],

  data() {
    const accountUrl = this.$store.state.auth.user.keycloak.createAccountUrl();
    const paramsPosition = accountUrl.indexOf('?');

    return {
      dialogVisible: false,
      // eslint-disable-next-line
      resetPasswordLink: `${accountUrl.substring(0,paramsPosition)}/password${accountUrl.substring(paramsPosition, accountUrl.length)}`,
      showBackButton: false,
    };
  },

  computed: mapState({
    user: state => state.auth.user,
  }),

  methods: {
    toggleMenu() {
      this.$store.dispatch('navigation/toggleMenu');
    },
    logout() {
      if (this.dialogVisible) {
        this.$store.dispatch('auth/logout');
      }
    },

    toggleLogoutDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
.highlight {
  font-weight: bold;
}

.drawer-list {
  padding: 16px;
}

.logo {
  width:140px;
}
</style>

<style>
.toolbar .v-toolbar__content {
  padding-left: 70px;
}

.sidebar-toggle {
  position: absolute;
  left: 20px;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
